<template>
  <v-select
    v-model="selectedLocale"
    :items="locales"
    item-title="label"
    item-value="code"
    :label="$t('global.basicTerms.language')"
    variant="outlined"
    density="compact"
    hide-details
    style="max-width: 180px"></v-select>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed, toRef } from 'vue';

import { useLocaleHelpers } from '@satellite/composables/useLocaleHelpers';
import { useLanguagePreferenceSync } from '@satellite/composables/useLanguagePreferenceSync';

const componentProps = defineProps<{ userId?: string | null }>();

const { locale } = useI18n();
const userIdRef = toRef(componentProps, 'userId');
const { setLocale: setUserLocale } = useLocaleHelpers(userIdRef);
const { setLocale: setGuestLocale } = useLocaleHelpers();
const { persistLanguagePreferenceOnChange } = useLanguagePreferenceSync(userIdRef);

const locales = [
  { code: 'en', label: 'English' },
  { code: 'es-mx', label: 'Español (MX)' },
  { code: 'pt-br', label: 'Portuguese (Brazil)' },
  { code: 'fr-ca', label: 'French Canadian' }
  // Add more as needed
];

const selectedLocale = computed({
  get: () => locale.value,
  set: async newLocale => {
    locale.value = newLocale;

    const userId = userIdRef.value;
    if (userId) {
      setUserLocale(newLocale);
      await persistLanguagePreferenceOnChange(userId, newLocale);
    }

    setGuestLocale(newLocale);
  }
});
</script>
